import Link from "next/link";
import { team_data } from "../../data/team_data";
import Image from "next/image";

const Team = () => {
  return (
    <section className="py-16 md:py-24 bg-[#FDF9FF] dark:bg-jacarta-900">
      <div className="container mx-auto px-4">
        <div className="text-center mb-[93px]">
          <h3 className="text-accent uppercase font-medium text-sm md:text-xl mb-2 tracking-wide">
            COLLABORATION FOR GOOD
          </h3>
          <h1 className="text-3xl md:text-5xl lg:text-5xl font-semibold text-grayish dark:text-white leading-snug">
            Meet Our Core Team and Advisors
          </h1>
        </div>

        <div className="max-w-7xl mx-auto">
          {/* First 10 people in 5-column grid */}
          <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-8 lg:gap-10 justify-items-center mb-12">
            {team_data.slice(0, 10).map((item) => {
              const { id, image, title, name, link } = item;
              return (
                <div
                  key={id}
                  className="flex flex-col items-center text-center p-3 sm:p-4 md:p-5 rounded-lg bg-white dark:bg-gradient-to-tr dark:from-[#0b1135] dark:to-[#241846] w-[150px] sm:w-[170px] md:w-[187px] h-[250px] sm:h-[270px] md:h-[292px]
                  backdrop-blur-xl border border-[#AE9CE2]/70 hover:border-[#AE9CE2] transition-all duration-300 cursor-default"
                >
                  <Image
                    width={130}
                    height={130}
                    src={image}
                    className="rounded-lg mx-auto mb-4 h-[90px] w-[90px] md:h-[120px] md:w-[120px] object-cover"
                    alt={name}
                  />
                  <h3 className="font-semibold text-grayish dark:text-white text-base mb-2">
                    {name}
                  </h3>
                  <span className="text-sm font-light tracking-tight mb-3">
                    {title}
                  </span>

                  <div className="mt-auto">
                    <Link
                      href={link}
                      className="group inline-block"
                      target="_blank"
                      aria-label={`${name}'s LinkedIn profile`}
                    >
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fab"
                        data-icon="linkedin"
                        className="group-hover:fill-accent fill-grayish/70 dark:fill-white/70 h-5 w-5 dark:group-hover:fill-accent"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                      >
                        <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"></path>
                      </svg>
                    </Link>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Last person and Join Us centered */}
          <div className="flex justify-center gap-4 md:gap-8 lg:gap-10">
            {team_data.slice(10).map((item) => {
              const { id, image, title, name, link } = item;
              return (
                <div
                  key={id}
                  className="flex flex-col items-center text-center p-3 sm:p-4 md:p-5 rounded-lg bg-white dark:bg-gradient-to-tr dark:from-[#0b1135] dark:to-[#241846] w-[150px] sm:w-[170px] md:w-[187px] h-[250px] sm:h-[270px] md:h-[292px]
                  backdrop-blur-xl border border-[#AE9CE2]/70 hover:border-[#AE9CE2] transition-all duration-300 cursor-default"
                >
                  <Image
                    width={130}
                    height={130}
                    src={image}
                    className="rounded-lg mx-auto mb-4 h-[90px] w-[90px] md:h-[120px] md:w-[120px] object-cover"
                    alt={name}
                  />
                  <h3 className="font-semibold text-grayish dark:text-white text-base mb-2">
                    {name}
                  </h3>
                  <span className="text-sm font-light tracking-tight mb-3">
                    {title}
                  </span>

                  <div className="mt-auto">
                    <Link
                      href={link}
                      className="group inline-block"
                      target="_blank"
                      aria-label={`${name}'s LinkedIn profile`}
                    >
                      <svg
                        aria-hidden="true"
                        focusable="false"
                        data-prefix="fab"
                        data-icon="linkedin"
                        className="group-hover:fill-accent fill-grayish/70 dark:fill-white/70 h-5 w-5 dark:group-hover:fill-accent"
                        role="img"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 448 512"
                      >
                        <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z"></path>
                      </svg>
                    </Link>
                  </div>
                </div>
              );
            })}

            <Link
              href="/contact"
              className="flex flex-col items-center justify-center text-center p-5 rounded-lg 
              dark:bg-transparent/10 backdrop-blur-xl border border-[#AE9CE2]/70 bg-white dark:bg-gradient-to-tr dark:from-[#0b1135] dark:to-[#241846] w-[150px] sm:w-[170px] md:w-[187px] h-[250px] sm:h-[270px] md:h-[292px]
              hover:border-[#AE9CE2] transition-all duration-300"
              aria-label="Join our team"
            >
              <span className="font-semibold text-grayish dark:text-white text-lg uppercase">
                JOIN US!
              </span>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Team;
